import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import 'vant/lib/index.css';
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import VueVideoPlayer from 'vue-video-player'
Vue.use(VueVideoPlayer)
import { Dialog,Swipe, SwipeItem } from 'vant';
import VueLazyLoad from 'vue-lazyload'//加载后台图片
import request from '@/utils/request'
import sdk from '@/utils/weixinSdk'
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.use(VueLazyLoad)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Dialog);

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.config.productionTip = false;
Vue.use(Antd);

/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS && to.path !== location.pathname) {
      location.assign(to.fullPath)
    } else {
      next()
    }
})
// 全局注册
require("@/api/api.js");//接口
//Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
  methods: {
    getUrlParms(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null)
       return unescape(r[2]);
      return null;
     },
    download() {
      window.location.href = "jt11trafficnews://";
      setTimeout(function() {
        Dialog.confirm({
          title: '',
          message: '即将离开当前应用'
        }).then(() => {
          window.location.href = "https://upgrade.jt11.com.cn/mobile/index.html"
        }).catch(() => {
          // on cancel
        });
      },800)
    },
    getWxInfo() {
      let _this = this;
      let url = "https://api.jt11.com.cn/api/v1/cms/Weixinshare/getSignature";
      return new Promise((resolve, reject) => {
        request({
          url: url,
          method: 'get', //查询一般为get
        }).then(response => {
          console.log(response)
          let obj = {};
          obj.appId = response.appId;
          obj.nonceStr = response.nonceStr;
          obj.signature = response.signature;
          obj.signature = response.signature;
          let objTitle = {
            title: "首页",
            desc: "交道内容",
            //link: window.location.href.split('#')[0],
           // imgUrl: imgUrl,
        }
        if(Global.env == 'https://api-dev.jt11.com.cn'){
          sdk.weixinShare("http://wap_dev.jt11.com.cn/homePage", objTitle,obj)
          }else if(Global.env == 'https://api-test.jt11.com.cn'){
            sdk.weixinShare("http://wap_test.jt11.com.cn/homePage", objTitle,obj)
          }else{
            sdk.weixinShare("https://m.jiaodao11.com/homePage", objTitle,obj)
          }
          return resolve()
        }).catch(error => {
          return reject(error);
        })
      })
    },
		
  },
  created () {
    this.getWxInfo();
  },  
}).$mount("#app");
